import { render, staticRenderFns } from "./MenuWrapper.vue?vue&type=template&id=3580e795&scoped=true"
import script from "./MenuWrapper.vue?vue&type=script&lang=js"
export * from "./MenuWrapper.vue?vue&type=script&lang=js"
import style0 from "./MenuWrapper.vue?vue&type=style&index=0&id=3580e795&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3580e795",
  null
  
)

export default component.exports